import { io } from 'socket.io-client';

import { config } from '../config/env';

const SOCKET_URL = config.SOCKET_URL;

class SocketService {
    constructor() {
        this.socket = null;
    }

    connect() {
        if (!this.socket) {
            console.log('Connecting to socket:', SOCKET_URL);

            this.socket = io(SOCKET_URL, {
                auth: {
                    token: localStorage.getItem('token')
                }
            });

            this.socket.on('connect', () => {
                console.log('Socket connected:', this.socket.id);
            });

            this.socket.on('disconnect', (reason) => {
                console.log('Socket disconnected:', reason);
            });

            this.socket.on('connect_error', (error) => {
                console.error('Socket connection error:', error);
            });

            // Log all incoming events for debugging
            // this.socket.onAny((eventName, ...args) => {
            //     console.log('Socket event received:', {
            //         event: eventName,
            //         argsCount: args.length,
            //         hasScreenshot: args[0]?.screenshot ? true : false,
            //         screenshotLength: args[0]?.screenshot?.length,
            //         data: args[0]
            //     });
            // });
        }
        return this.socket;
    }

    disconnect() {
        if (this.socket) {
            this.socket.disconnect();
            this.socket = null;
        }
    }

    joinWorkspace(workspaceId) {
        if (this.socket) {
            this.socket.emit('join:workspace', workspaceId);
        }
    }

    leaveWorkspace(workspaceId) {
        if (this.socket) {
            this.socket.emit('leave:workspace', workspaceId);
        }
    }

    onTestUpdate(callback) {
        if (this.socket) {
            this.socket.on('test:update', callback);
        }
    }

    offTestUpdate(callback) {
        if (this.socket) {
            this.socket.off('test:update', callback);
        }
    }
}

export default new SocketService();
